/**
 * @generated SignedSource<<327c0007548dd26e670180c2231af9de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EditBaselineTemplatePageQuery$variables = {
  id: string;
};
export type EditBaselineTemplatePageQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly company: {
      readonly id: string;
      readonly currency: string | null;
      readonly roles: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly disabled: boolean | null;
          } | null;
        } | null> | null;
      } | null;
      readonly expenseCategories: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly disabled: boolean | null;
          } | null;
        } | null> | null;
      } | null;
      readonly baselineTemplates: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
      } | null> | null;
      readonly baselineTemplate: {
        readonly id: string;
        readonly name: string | null;
        readonly description: string | null;
        readonly includeDeliverables: boolean | null;
        readonly deliverables: ReadonlyArray<{
          readonly id: string | null;
          readonly name: string | null;
          readonly description: string | null;
        } | null> | null;
        readonly phases: ReadonlyArray<{
          readonly name: string | null;
          readonly startWeek: number | null;
          readonly durationDays: number | null;
          readonly deliverableIds: ReadonlyArray<string | null> | null;
          readonly timeEstimates: ReadonlyArray<{
            readonly roleId: string | null;
            readonly minutes: number | null;
            readonly deliverableId: string | null;
          } | null> | null;
          readonly expenseEstimates: ReadonlyArray<{
            readonly name: string | null;
            readonly expenseCategoryId: string | null;
            readonly revenue: number | null;
            readonly cost: number | null;
            readonly deliverableId: string | null;
          } | null> | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type EditBaselineTemplatePageQuery = {
  variables: EditBaselineTemplatePageQuery$variables;
  response: EditBaselineTemplatePageQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "settings_edit_baseline_template"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"settings_edit_baseline_template\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disabled",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverableId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "company",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v4/*: any*/),
        {
          "kind": "Literal",
          "name": "includeDisabled",
          "value": true
        }
      ],
      "concreteType": "RoleTypeConnection",
      "kind": "LinkedField",
      "name": "roles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v6/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roles(first:10000,includeDisabled:true)"
    },
    {
      "alias": null,
      "args": [
        (v4/*: any*/)
      ],
      "concreteType": "ExpenseCategoryTypeConnection",
      "kind": "LinkedField",
      "name": "expenseCategories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseCategoryTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseCategory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v6/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "expenseCategories(first:10000)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineTemplate",
      "kind": "LinkedField",
      "name": "baselineTemplates",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "BaselineTemplateDetail",
      "kind": "LinkedField",
      "name": "baselineTemplate",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v5/*: any*/),
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includeDeliverables",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BaselineTemplateDetailDeliverable",
          "kind": "LinkedField",
          "name": "deliverables",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v5/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BaselineTemplateDetailPhase",
          "kind": "LinkedField",
          "name": "phases",
          "plural": true,
          "selections": [
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startWeek",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "durationDays",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliverableIds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BaselineTemplateDetailTimeEstimate",
              "kind": "LinkedField",
              "name": "timeEstimates",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roleId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutes",
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BaselineTemplateDetailExpenseEstimate",
              "kind": "LinkedField",
              "name": "expenseEstimates",
              "plural": true,
              "selections": [
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseCategoryId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "revenue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cost",
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBaselineTemplatePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditBaselineTemplatePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v9/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "108aa7e86cd5de3027db3121cb405bf9",
    "id": null,
    "metadata": {},
    "name": "EditBaselineTemplatePageQuery",
    "operationKind": "query",
    "text": "query EditBaselineTemplatePageQuery(\n  $id: ID!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"settings_edit_baseline_template\")\n    company {\n      id\n      currency\n      roles(first: 10000, includeDisabled: true) {\n        edges {\n          node {\n            id\n            name\n            disabled\n          }\n        }\n      }\n      expenseCategories(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            disabled\n          }\n        }\n      }\n      baselineTemplates {\n        id\n        name\n      }\n      baselineTemplate(id: $id) {\n        id\n        name\n        description\n        includeDeliverables\n        deliverables {\n          id\n          name\n          description\n        }\n        phases {\n          name\n          startWeek\n          durationDays\n          deliverableIds\n          timeEstimates {\n            roleId\n            minutes\n            deliverableId\n          }\n          expenseEstimates {\n            name\n            expenseCategoryId\n            revenue\n            cost\n            deliverableId\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "030b09907b9b7c44d37cb045371c7646";

export default node;
